(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[30],{

/***/ "C9cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createPropsForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRentalAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getServiceAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getServiceAgesLabelTranslateOptions; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");



var IS_DISABLED = 'isDisabled';
var IS_ENABLED = 'isEnabled';
var IS_SELECTED = 'isSelected';

var getServiceAgesLabel = function getServiceAgesLabel(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    });
  }

  if (min < 23 && max && max > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    });
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  });
};

function getServiceAgesLabelTranslateOptions(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return ['booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    }];
  }

  if (min < 23 && max && max > 23) {
    return ['booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    }];
  }

  return ['booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  }];
}

var getRentalAgesLabel = function getRentalAgesLabel(ageInMonths) {
  if (!ageInMonths || !ageInMonths.min) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.forAllAges');
  }

  if (ageInMonths.max) {
    return getServiceAgesLabel(ageInMonths);
  }

  if (ageInMonths.min < 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.ageFromMonths', {
      amount: ageInMonths.min
    });
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.activities.ageFrom', {
    age: Math.floor(ageInMonths.min / 12)
  });
};

var createPropsForPictures = function createPropsForPictures(images) {
  if (!Array.isArray(images)) {
    return [];
  }

  return images.map(function (link) {
    return {
      src: link
    };
  });
};

var createPropsForProduct = function createPropsForProduct(resort) {
  var _resort$destination;

  return {
    id: resort.id,
    header: {
      className: 'border-r-1',
      heading: {
        subtitle: resort === null || resort === void 0 ? void 0 : (_resort$destination = resort.destination) === null || _resort$destination === void 0 ? void 0 : _resort$destination.country,
        title: resort.name || ''
      },
      link: {
        url: resort.href
      },
      productId: resort.id,
      productType: resort.type
    },
    thumbnail: {
      link: {
        url: resort.href
      },
      pictures: createPropsForPictures(resort.images),
      productId: resort.id,
      productType: resort.type
    },
    url: resort.href,
    type: resort.type || ''
  };
};



/***/ }),

/***/ "DQFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSlideShow; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("u/u4");
/* harmony import */ var _arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Gy6l");
/* harmony import */ var _backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("NZxu");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("0IQ5");
/* harmony import */ var _slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("A5Hi");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;








var ImageSlideShow = function ImageSlideShow(_ref) {
  var centerPadding = _ref.centerPadding,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      fadeUnseenItems = _ref.fadeUnseenItems,
      galleryLabel = _ref.galleryLabel,
      _ref$groupKey = _ref.groupKey,
      groupKey = _ref$groupKey === void 0 ? 'thumbnails' : _ref$groupKey,
      hasFullScreenMode = _ref.hasFullScreenMode,
      hasOverlappingControls = _ref.hasOverlappingControls,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      hasLazyLoading = _ref.hasLazyLoading,
      itemClassName = _ref.itemClassName,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      _ref$nbItemsToShow = _ref.nbItemsToShow,
      nbItemsToShow = _ref$nbItemsToShow === void 0 ? 1 : _ref$nbItemsToShow,
      nextLabel = _ref.nextLabel,
      onChangeIndex = _ref.onChangeIndex,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_5__[/* default */ "c"].XL : _ref$ratio,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 : _ref$ratioDisplay,
      _ref$spacerWidth = _ref.spacerWidth,
      spacerWidth = _ref$spacerWidth === void 0 ? 0 : _ref$spacerWidth;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(false),
      isFullScreen = _useState[0],
      setIsFullScreen = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(0),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  if (!media.length) {
    return null;
  }

  var updateActiveIndex = function updateActiveIndex(index) {
    setActiveIndex(index);
  };

  var gk = hasFullScreenMode ? null : groupKey;
  var items = media.filter(function (_ref2) {
    var src = _ref2.src;
    return Boolean(src);
  }).map(function (_ref3) {
    var _ref3$alt = _ref3.alt,
        alt = _ref3$alt === void 0 ? '' : _ref3$alt,
        _onClick = _ref3.onClick,
        src = _ref3.src;

    var children = __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_8__[/* default */ "b"], {
      altMsg: alt,
      className: itemClassName,
      groupKey: gk,
      hasLazyLoading: hasLazyLoading,
      imageUrl: src,
      key: src,
      ratioKey: ratio,
      ratioDisplay: ratioDisplay,
      spacerWidth: ratioDisplay
    });

    var isButton = hasFullScreenMode || _onClick;
    return __jsx(react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], {
      key: "Image-".concat(src)
    }, isButton ? __jsx("button", {
      className: "block h-full w-full",
      onClick: function onClick() {
        _onClick && _onClick();

        if (hasFullScreenMode) {
          setIsFullScreen(true);
        }
      },
      type: "button"
    }, children) : __jsx("div", {
      className: "h-full"
    }, children));
  });
  return __jsx(_slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_9__[/* SliderHandler */ "a"], {
    centerPadding: centerPadding,
    fadeUnseenItems: fadeUnseenItems,
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items,
    nbItemsToShow: nbItemsToShow,
    onChangeIndex: updateActiveIndex,
    spacerWidth: spacerWidth
  }, function (_ref4) {
    var hasControls = _ref4.hasControls,
        isNextControlDisabled = _ref4.isNextControlDisabled,
        isPreviousControlDisabled = _ref4.isPreviousControlDisabled,
        itemsNode = _ref4.itemsNode,
        onNext = _ref4.onNext,
        onPrevious = _ref4.onPrevious;
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, 'group relative')
    }, itemsNode, hasControls && __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('transition-opacity duration-250 ease-in will-change-transform absolute flex items-center justify-between m-auto inset-0 pointer-events-none w-full z-2', {
        'px-10 sm:px-20': !hasOverlappingControls
      }),
      "data-testid": "ImageSlideShow-controls-parent"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('me-auto pointer-events-auto shadow-sm z-2', {
        'transform -translate-x-1/2': hasOverlappingControls
      }),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('ms-auto pointer-events-auto shadow-sm z-2', {
        'transform translate-x-1/2': hasOverlappingControls
      }),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })), hasFullScreenMode && isFullScreen && __jsx(_backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_7__[/* Backdrop */ "a"], {
      ariaLabel: galleryLabel,
      closeLabel: closeLabel,
      hasCloseButton: true,
      onClose: function onClose() {
        return setIsFullScreen(false);
      }
    }, __jsx("div", {
      className: "relative w-full"
    }, itemsNode, hasControls && __jsx("div", {
      className: "absolute flex items-center justify-between m-auto inset-0 pointer-events-none px-10 sm:px-20 w-full"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: "me-auto pointer-events-auto shadow-sm z-2",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_6__[/* ArrowButton */ "a"], {
      className: "ms-auto pointer-events-auto shadow-sm z-2",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].WHITE,
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })))));
  });
};

/***/ }),

/***/ "ELg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductFlag_ProductFlag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 5 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx + 1 modules
var ProductPriceModal = __webpack_require__("yfdt");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.themes.js
var themes = {
  thumbnail: {
    thPriceTheme: 'inline'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx



var __jsx = react_default.a.createElement;









var ProductFlag_ProductFlag = function ProductFlag(_ref) {
  var _ref$isLinkDisabled = _ref.isLinkDisabled,
      isLinkDisabled = _ref$isLinkDisabled === void 0 ? false : _ref$isLinkDisabled,
      _ref$isPriceLoading = _ref.isPriceLoading,
      isPriceLoading = _ref$isPriceLoading === void 0 ? false : _ref$isPriceLoading,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop_default.a : _ref$onClick,
      _ref$onCtaClick = _ref.onCtaClick,
      onCtaClick = _ref$onCtaClick === void 0 ? noop_default.a : _ref$onCtaClick,
      _ref$onEmptyPriceClic = _ref.onEmptyPriceClick,
      onEmptyPriceClick = _ref$onEmptyPriceClic === void 0 ? noop_default.a : _ref$onEmptyPriceClic,
      _ref$onIconBubbleClic = _ref.onIconBubbleClick,
      onIconBubbleClick = _ref$onIconBubbleClic === void 0 ? noop_default.a : _ref$onIconBubbleClic,
      _ref$onPriceClick = _ref.onPriceClick,
      onPriceClick = _ref$onPriceClick === void 0 ? noop_default.a : _ref$onPriceClick,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? {} : _ref$price,
      _ref$priceInfo = _ref.priceInfo,
      priceInfo = _ref$priceInfo === void 0 ? {} : _ref$priceInfo,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'thumbnail' : _ref$theme;

  if (isEmpty_default()(price)) {
    return null;
  }

  var thPriceTheme = themes[theme].thPriceTheme;
  var hasPrice = !isPriceLoading && Object(price_util["d" /* hasAtLeastOnePrice */])(price);

  var handleEmptyPriceClick = function handleEmptyPriceClick() {
    onEmptyPriceClick && onEmptyPriceClick();

    if (!isLinkDisabled) {
      onClick && onClick();
    }
  };

  var handlePriceClick = function handlePriceClick() {
    onPriceClick && onPriceClick();
  };

  var handleProductPriceModalOnClickButton = function handleProductPriceModalOnClickButton() {
    onCtaClick && onCtaClick();
    onClick && onClick();
  };

  var priceNode = __jsx("span", {
    className: "flex gap-5"
  }, __jsx("button", {
    className: "flex items-center justify-end w-full",
    onClick: hasPrice ? handlePriceClick : handleEmptyPriceClick,
    type: "button"
  }, __jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({
    color: colors["a" /* COLORS */].SIENNA
  }, price, {
    "data-testid": "Price-wrapper",
    from: price.from,
    hasInitialPrice: true,
    isLoading: isPriceLoading,
    theme: thPriceTheme
  }))), hasPrice && Object(i18n["d" /* getKeyValue */])('price.displayIconBubble') && __jsx("button", {
    className: "mt-5",
    onClick: function onClick() {
      return onIconBubbleClick && onIconBubbleClick();
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].SIENNA,
    name: icons["a" /* ICONS */].INFORMATION,
    width: "1.25rem"
  })));

  return hasPrice ? __jsx(ProductPriceModal["a" /* ProductPriceModal */], Object(esm_extends["a" /* default */])({}, priceInfo, {
    onClickButton: handleProductPriceModalOnClickButton
  }), priceNode) : __jsx("div", {
    className: "m-5"
  }, priceNode);
};

/***/ }),

/***/ "Fe0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export grid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateProductLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateLinkProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return localeHasCmtaLinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateCmtaLinkProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCruiseExclusivity; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("igjW");
/* harmony import */ var _utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("0JpG");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("CcNa");







var grid = {
  mobile: 1,
  phablet: 2,
  tablet: 3,
  desktop: 3
};
var generateProductLink = function generateProductLink(url, offer) {
  var newLink = offer && offer.seoName ? new urijs__WEBPACK_IMPORTED_MODULE_2___default.a(url).addSearch(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["appQueryParameters"].shopping.offer, _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeSlug(offer.seoName)).toString() : url;
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeUrl(newLink);
};
var generateLinkProp = function generateLinkProp(url, offer) {
  return url ? {
    url: generateProductLink(url, offer),
    queryParamsToIgnore: offer ? [] : ['offer']
  } : undefined;
};
var localeHasCmtaLinks = function localeHasCmtaLinks(cmtaLinks) {
  return cmtaLinks && cmtaLinks.cmtaIntegLink && cmtaLinks.cmtaStagingLink && cmtaLinks.cmtaProdLink;
};
var generateCmtaLinkProp = function generateCmtaLinkProp(resortId, cmtaLinks) {
  var cmtaIntegLink = cmtaLinks.cmtaIntegLink,
      cmtaStagingLink = cmtaLinks.cmtaStagingLink,
      cmtaProdLink = cmtaLinks.cmtaProdLink;
  var cmtaUrl = cmtaProdLink;

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__[/* isStrictlyIntegrationEnv */ "e"])()) {
    cmtaUrl = cmtaIntegLink;
  }

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__[/* isStrictlyStagingEnv */ "g"])()) {
    cmtaUrl = cmtaStagingLink;
  }

  return {
    url: cmtaUrl + resortId,
    isExternalLink: true
  };
};
var getCruiseExclusivity = function getCruiseExclusivity() {
  var _data$cruiseExclusivi;

  var productId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _runGQLQuery = Object(_utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_5__[/* useGQL */ "a"])({
    query: "query {\n      cruiseExclusivity(productId: \"".concat(productId, "\") {\n        isExclusive\n      }\n    }"),
    queryOptions: {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_6__[/* LINE_CRUISE_EXCLUSIVITY */ "Ab"]
    }
  }),
      data = _runGQLQuery.data,
      isCruiseExclusivityLoading = _runGQLQuery.isLoading;

  return {
    isCruiseExclusive: !!(data === null || data === void 0 ? void 0 : (_data$cruiseExclusivi = data.cruiseExclusivity) === null || _data$cruiseExclusivi === void 0 ? void 0 : _data$cruiseExclusivi.isExclusive),
    isCruiseExclusivityLoading: isCruiseExclusivityLoading
  };
};

/***/ }),

/***/ "Gqxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _ResponsiveContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("1JJ2");










var __jsx = react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




function Responsiveness(WrappedComponent) {
  var Responsive = /*#__PURE__*/function (_Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Responsive, _Component);

    var _super = _createSuper(Responsive);

    function Responsive() {
      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, Responsive);

      return _super.apply(this, arguments);
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Responsive, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            ref = _this$props.forwardRef,
            props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_this$props, ["forwardRef"]);

        return __jsx(_ResponsiveContext__WEBPACK_IMPORTED_MODULE_11__[/* ResponsiveContext */ "a"].Consumer, null, function (responsive) {
          return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({
            ref: ref
          }, props, {
            responsive: responsive
          }));
        });
      }
    }]);

    return Responsive;
  }(react__WEBPACK_IMPORTED_MODULE_10__["Component"]);

  return /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_10__["forwardRef"])(function (props, ref) {
    return __jsx(Responsive, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, props, {
      forwardRef: ref
    }));
  });
}

/* harmony default export */ __webpack_exports__["a"] = (Responsiveness);

/***/ }),

/***/ "IuYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Price_Price; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.themes.js

var themes = {
  "default": function _default(_ref) {
    var color = _ref.color,
        hasInitialPriceDisplayed = _ref.hasInitialPriceDisplayed;
    return {
      thRoot: 'flex flex-wrap gap-x-10 isolate items-baseline relative text-14',
      thFirstLine: 'flex gap-x-10 items-baseline',
      thFrom: classnames_default()('text-12 first-letter:uppercase', {
        'absolute top-0': hasInitialPriceDisplayed
      }),
      thInitialPrice: "font-semibold line-through text-14 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold text-32',
      thUnit: 'text-12'
    };
  },
  column: function column(_ref2) {
    var color = _ref2.color;
    return {
      thRoot: 'flex flex-col isolate leading-tight relative text-14',
      thFirstLine: 'flex gap-x-10 items-baseline',
      thFrom: 'first-letter:uppercase',
      thInitialPrice: "font-semibold line-through text-14 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold text-28 w-full',
      thUnit: 'text-12'
    };
  },
  inline: function inline(_ref3) {
    var color = _ref3.color;
    return {
      thRoot: 'flex gap-x-5 isolate items-baseline relative text-10 sm:text-12',
      thFirstLine: 'flex gap-x-5 items-baseline shrink-0',
      thFrom: 'first-letter:uppercase',
      thInitialPrice: "font-semibold line-through text-10 sm:text-12 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold shrink-0 text-20 underline',
      thUnit: 'text-10 sm:text-12'
    };
  },
  inlineSmall: function inlineSmall(_ref4) {
    var color = _ref4.color;
    return {
      thRoot: 'flex gap-x-5 isolate items-baseline relative text-10 sm:text-12',
      thFirstLine: 'flex gap-x-5 items-baseline',
      thFrom: 'first-letter:uppercase',
      thInitialPrice: "font-semibold line-through text-10 sm:text-12 text-".concat(color),
      thTotalPrice: 'font-semibold text-14 text-green',
      thBestPrice: 'font-bold text-14 sm:text-20',
      thUnit: 'text-10 sm:text-12'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.jsx


var __jsx = react_default.a.createElement;








var PriceDiscount_PriceDiscount = function PriceDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SIENNA : _ref$color,
      from = _ref.from,
      hasAsterisk = _ref.hasAsterisk,
      _ref$hasDiscount = _ref.hasDiscount,
      hasDiscount = _ref$hasDiscount === void 0 ? false : _ref$hasDiscount,
      _ref$hasInitialPrice = _ref.hasInitialPrice,
      hasInitialPrice = _ref$hasInitialPrice === void 0 ? false : _ref$hasInitialPrice,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? true : _ref$hasInstalment,
      _ref$hasTotalPrice = _ref.hasTotalPrice,
      hasTotalPrice = _ref$hasTotalPrice === void 0 ? false : _ref$hasTotalPrice,
      initialPrice = _ref.initialPrice,
      showTaxesAndFeesIncludedLabel = _ref.showTaxesAndFeesIncludedLabel,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      unit = _ref.unit,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["bestPrice", "className", "color", "from", "hasAsterisk", "hasDiscount", "hasInitialPrice", "hasInstalment", "hasTotalPrice", "initialPrice", "showTaxesAndFeesIncludedLabel", "theme", "unit"]);

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var initialPriceFormattedValue = hasInstalment && initialPrice ? Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Math.floor(initialPrice.value), locale, initialPrice.currency, {
    precision: 0
  }) : initialPrice && initialPrice.formattedValue;
  var totalBestPrice = bestPrice && bestPrice.formattedValue;
  var bestPriceFormattedValue = hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])(bestPrice, locale) : totalBestPrice;
  var hasInitialPriceDisplayed = hasInitialPrice && initialPriceFormattedValue && (hasDiscount || !bestPrice);
  var hasTotalPriceDisplayed = hasTotalPrice && hasInstalment && bestPriceFormattedValue !== totalBestPrice;

  var _themes$theme = themes[theme]({
    color: color,
    hasInitialPriceDisplayed: hasInitialPriceDisplayed
  }),
      thBestPrice = _themes$theme.thBestPrice,
      thFirstLine = _themes$theme.thFirstLine,
      thFrom = _themes$theme.thFrom,
      thInitialPrice = _themes$theme.thInitialPrice,
      thRoot = _themes$theme.thRoot,
      thTotalPrice = _themes$theme.thTotalPrice,
      thUnit = _themes$theme.thUnit;

  return __jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: classnames_default()(className, thRoot)
  }), (hasInitialPriceDisplayed || hasTotalPriceDisplayed || from) && __jsx("span", {
    className: thFirstLine
  }, from && __jsx("span", {
    className: thFrom
  }, from), hasInitialPriceDisplayed && __jsx("span", {
    className: thInitialPrice,
    "data-testid": "PriceItem-value"
  }, initialPriceFormattedValue), hasTotalPriceDisplayed && __jsx("span", {
    className: thTotalPrice,
    "data-testid": "PriceItem-value"
  }, totalBestPrice)), bestPriceFormattedValue && __jsx("span", {
    className: thBestPrice,
    "data-testid": "PriceItem-value"
  }, bestPriceFormattedValue), unit && __jsx("div", {
    className: thUnit
  }, showTaxesAndFeesIncludedLabel && Object(i18n["d" /* getKeyValue */])(Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.displayTaxesAndFeesIncludedMention')) ? null : unit, hasAsterisk && __jsx("sup", null, "*"), showTaxesAndFeesIncludedLabel && Object(i18n["d" /* getKeyValue */])(Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.displayTaxesAndFeesIncludedMention')) && __jsx("div", null, Object(i18n["h" /* t */])('booking.priceDetails.packagePrice.fees.taxesAndFeesIncludedLabel'))));
};
// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.themes.js
var PriceViewRate_themes_themes = {
  "default": {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16'
  },
  column: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16'
  },
  inline: {
    thRoot: 'flex gap-5 items-center font-sans font-semibold leading-1 text-16'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.jsx


var PriceViewRate_jsx = react_default.a.createElement;





var PriceViewRate_PriceViewRate = function PriceViewRate(_ref) {
  var className = _ref.className,
      label = _ref.label,
      theme = _ref.theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["className", "label", "theme"]);

  var _themes$theme = PriceViewRate_themes_themes[theme],
      thIcon = _themes$theme.thIcon,
      thRoot = _themes$theme.thRoot;

  if (!label) {
    return null;
  }

  return PriceViewRate_jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: classnames_default()(className, thRoot)
  }), PriceViewRate_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].DATE,
    width: "1em"
  }), label);
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/prices/Prices.jsx


var Prices_jsx = react_default.a.createElement;






var Prices_PriceLoader = function PriceLoader(_ref) {
  var className = _ref.className;
  return Prices_jsx("span", {
    className: classnames_default()(className, 'block after:animate-loadingDots after:content-["."] pr-30 text-32 w-[2em]'),
    "data-testid": "Price-loader"
  });
};

var Prices_Prices = function Prices(_ref2) {
  var bestPrice = _ref2.bestPrice,
      className = _ref2.className,
      color = _ref2.color,
      from = _ref2.from,
      hasAsterisk = _ref2.hasAsterisk,
      hasInitialPrice = _ref2.hasInitialPrice,
      hasInstalment = _ref2.hasInstalment,
      hasTotalPrice = _ref2.hasTotalPrice,
      initialPrice = _ref2.initialPrice,
      isLoading = _ref2.isLoading,
      showTaxesAndFeesIncludedLabel = _ref2.showTaxesAndFeesIncludedLabel,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme,
      unit = _ref2.unit,
      viewRates = _ref2.viewRates,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref2, ["bestPrice", "className", "color", "from", "hasAsterisk", "hasInitialPrice", "hasInstalment", "hasTotalPrice", "initialPrice", "isLoading", "showTaxesAndFeesIncludedLabel", "theme", "unit", "viewRates"]);

  var displayPrice = Object(price_util["d" /* hasAtLeastOnePrice */])({
    initialPrice: initialPrice,
    bestPrice: bestPrice
  });

  if (isLoading) {
    return Prices_jsx(Prices_PriceLoader, {
      className: className
    });
  }

  if (!displayPrice && !viewRates) {
    return null;
  }

  if (!displayPrice) {
    return Prices_jsx(PriceViewRate_PriceViewRate, Object(esm_extends["a" /* default */])({}, rest, {
      className: className,
      label: viewRates,
      theme: theme
    }));
  }

  return Prices_jsx(PriceDiscount_PriceDiscount, Object(esm_extends["a" /* default */])({}, rest, {
    bestPrice: bestPrice,
    className: className,
    color: color,
    from: from,
    hasAsterisk: hasAsterisk,
    hasDiscount: Object(price_util["e" /* hasDiscount */])({
      bestPrice: bestPrice,
      initialPrice: initialPrice
    }),
    hasInitialPrice: hasInitialPrice,
    hasInstalment: hasInstalment,
    hasTotalPrice: hasTotalPrice,
    initialPrice: initialPrice,
    unit: unit,
    theme: theme,
    showTaxesAndFeesIncludedLabel: showTaxesAndFeesIncludedLabel
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.jsx



var Price_jsx = react_default.a.createElement;




var INSTALMENT_LOCALES = ['pt-BR', 'es-AR'];
var Price_Price = function Price(_ref) {
  var _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? true : _ref$hasInstalment,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["hasInstalment"]);

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale;

  var displayInstalment = hasInstalment && Object(i18n["d" /* getKeyValue */])('common.price.displayInstalmentsPrice') && INSTALMENT_LOCALES.includes(locale);
  return Price_jsx(Prices_Prices, Object(esm_extends["a" /* default */])({}, props, {
    hasInstalment: displayInstalment
  }));
};

/***/ }),

/***/ "N5WC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Tag_Tag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.themes.js



var themes = {
  "default": function _default(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref$color,
        _ref$colorBg = _ref.colorBg,
        colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].SAFFRON : _ref$colorBg,
        colorBorder = _ref.colorBorder;
    return {
      thRoot: classnames_default()("bg-".concat(colorBg, " border-1 border-").concat(colorBorder || colorBg, " text-").concat(color), 'font-bold font-sans gap-5 inline-flex items-center leading-1 overflow-hidden px-10 py-5 rounded-pill text-12 whitespace-nowrap')
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.jsx


var __jsx = react_default.a.createElement;




var Tag_Tag = function Tag(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      colorBg = _ref.colorBg,
      colorBorder = _ref.colorBorder,
      iconName = _ref.iconName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "className", "color", "colorBg", "colorBorder", "iconName", "theme"]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme]({
    color: color,
    colorBg: colorBg,
    colorBorder: colorBorder
  }),
      thRoot = _themes$theme.thRoot;

  return __jsx("span", Object(esm_extends["a" /* default */])({}, rest, {
    className: classnames_default()(className, thRoot)
  }), __jsx(Icon["a" /* Icon */], {
    className: "shrink-0",
    color: color,
    name: iconName,
    width: "1em"
  }), children);
};

/***/ }),

/***/ "XTOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_Product; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__("MwrP");
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/camelCase.js
var camelCase = __webpack_require__("S0cN");
var camelCase_default = /*#__PURE__*/__webpack_require__.n(camelCase);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.utils.js
var Product_utils = __webpack_require__("Fe0B");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/tag/Tag.jsx + 1 modules
var Tag = __webpack_require__("N5WC");

// CONCATENATED MODULE: ./src/client/components/widgets/offer-discount/OfferDiscount.jsx
var __jsx = react_default.a.createElement;



var OfferDiscount_OfferDiscount = function OfferDiscount(_ref) {
  var _discount$amount;

  var className = _ref.className,
      discount = _ref.discount,
      i18n = _ref.i18n;
  var offerName = (discount === null || discount === void 0 ? void 0 : discount.offerName) || (i18n === null || i18n === void 0 ? void 0 : i18n.defaultLabel) || '';
  var backgroundColor = (discount === null || discount === void 0 ? void 0 : discount.offerColor) || (i18n === null || i18n === void 0 ? void 0 : i18n.defaultColor) || null;
  return (discount === null || discount === void 0 ? void 0 : (_discount$amount = discount.amount) === null || _discount$amount === void 0 ? void 0 : _discount$amount.value) ? __jsx(Tag["a" /* Tag */], {
    className: className,
    color: colors["a" /* COLORS */].WHITE,
    style: {
      backgroundColor: backgroundColor
    }
  }, offerName) : null;
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-header/ProductHeader.jsx
var ProductHeader = __webpack_require__("hgS3");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-comparison/ProductComparison.jsx

var ProductComparison_jsx = react_default.a.createElement;





var ProductComparison_ProductComparison = function ProductComparison(_ref) {
  var className = _ref.className,
      eligibilityLabel = _ref.eligibilityLabel,
      isEligible = _ref.isEligible,
      label = _ref.label,
      onComparisonClick = _ref.onComparisonClick,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? product_utils["b" /* IS_ENABLED */] : _ref$status;

  if (!isEligible) {
    return ProductComparison_jsx("div", {
      className: "absolute bg-white/60 flex font-bold inset-0 items-center justify-center p-20 rounded-12 text-14 text-center z-1"
    }, eligibilityLabel);
  }

  var isSelectable = status !== product_utils["a" /* IS_DISABLED */];
  var isSelected = status === product_utils["c" /* IS_SELECTED */];
  var buttonProps = isSelectable ? {
    onClick: onComparisonClick,
    type: 'button',
    title: label
  } : null;
  var TagName = isSelectable ? 'button' : 'div';
  return ProductComparison_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()(className, 'absolute bg-darkGrey/40 flex h-full inset-0 items-center justify-center p-20 rounded-12 text-white w-full z-1')
  }, buttonProps), isSelectable && ProductComparison_jsx("span", {
    className: classnames_default()('aspect-square border-2 leading-0 p-10 rounded-full transition-colors duration-250 ease-in', {
      'bg-transparent border-white': !isSelected,
      'bg-saffron border-saffron text-black': isSelected
    })
  }, ProductComparison_jsx(Icon["a" /* Icon */], {
    name: isSelected ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].PLUS,
    width: "1.25rem"
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx + 1 modules
var ProductFlag = __webpack_require__("ELg1");

// EXTERNAL MODULE: ./src/client/components/widgets/product/product-thumbnail/ProductThumbnail.jsx
var ProductThumbnail = __webpack_require__("Z+2E");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/Availability.jsx
var Availability_jsx = react_default.a.createElement;




var computeAvailabilityStatus = function computeAvailabilityStatus(_ref) {
  var availability = _ref.availability,
      remainingStock = _ref.remainingStock;

  switch (true) {
    case availability === 'UNAVAILABLE':
    case availability === 'AVAILABLE' && remainingStock === 0:
      return 'unavailable';

    case availability === 'AVAILABLE' && remainingStock !== null && +remainingStock < 10:
    case availability === 'PARTIAL':
      return 'remaining';

    case availability === 'AVAILABLE':
      return 'available';

    default:
      return 'unknown';
  }
};

var Availability_Availability = function Availability(_ref2) {
  var availability = _ref2.availability,
      config = _ref2.config,
      remainingStock = _ref2.remainingStock;
  var availabilityStatus = computeAvailabilityStatus({
    availability: availability,
    remainingStock: remainingStock
  });

  var _ref3 = config[availabilityStatus] || {},
      color = _ref3.color,
      icon = _ref3.icon,
      label = _ref3.label;

  return label ? Availability_jsx("span", {
    className: "flex flex-none shrink gap-5 items-center text-".concat(color, " text-end")
  }, icon && Availability_jsx(Icon["a" /* Icon */], {
    name: icon,
    width: "0.8rem"
  }), Object(dist["messageFormat"])(label).format({
    count: remainingStock
  })) : null;
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/AvailabilityAge.jsx
var AvailabilityAge_jsx = react_default.a.createElement;



var shouldShowAgeInMonth = function shouldShowAgeInMonth(ageInNumberOfMonths) {
  return ageInNumberOfMonths <= 23;
};

var shouldShowAgeInYearsRange = function shouldShowAgeInYearsRange(ageMin, ageMax) {
  return !(Math.floor(ageMin / 12) === Math.floor(ageMax / 12));
};

var AvailabilityAge_AvailabilityAge = function AvailabilityAge(_ref) {
  var ageMax = _ref.ageMax,
      ageMin = _ref.ageMin,
      childcareLabel = _ref.childcareLabel,
      monthsLabel = _ref.monthsLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var message = '';

  if (shouldShowAgeInMonth(ageMax)) {
    message = Object(dist["messageFormat"])(monthsLabel).format({
      min: ageMin,
      max: ageMax
    });
  } else if (shouldShowAgeInYearsRange(ageMin, ageMax)) {
    message = Object(dist["messageFormat"])(yearsLabel).format({
      min: Math.floor(ageMin / 12),
      max: Math.floor(ageMax / 12)
    });
  } else {
    // Shows a single year age
    message = Object(dist["messageFormat"])(yearLabel).format({
      fixed: Math.floor(ageMin / 12)
    });
  }

  return AvailabilityAge_jsx(react["Fragment"], null, "".concat(childcareLabel, " "), AvailabilityAge_jsx("span", {
    className: "font-normal whitespace-nowrap"
  }, "(", message, ")"));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/productChildcareAvailabilities.jsx

var productChildcareAvailabilities_jsx = react_default.a.createElement;







var productChildcareAvailabilities_ProductChildcareAvailabilities = function ProductChildcareAvailabilities(_ref) {
  var availableLabel = _ref.availableLabel,
      childcareLabel = _ref.childcareLabel,
      items = _ref.items,
      monthsLabel = _ref.monthsLabel,
      remainingLabel = _ref.remainingLabel,
      unavailableLabel = _ref.unavailableLabel,
      unknownLabel = _ref.unknownLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var renderConfig = {
    available: {
      color: colors["a" /* COLORS */].GREEN,
      icon: icons["a" /* ICONS */].CHECK,
      label: availableLabel
    },
    remaining: {
      color: colors["a" /* COLORS */].ORANGE,
      icon: icons["a" /* ICONS */].WARNING,
      label: remainingLabel
    },
    unavailable: {
      color: colors["a" /* COLORS */].RED,
      icon: icons["a" /* ICONS */].CROSS,
      label: unavailableLabel
    },
    unknown: {
      color: colors["a" /* COLORS */].MEDIUM_GREY,
      label: unknownLabel
    }
  };
  return productChildcareAvailabilities_jsx(react["Fragment"], null, items.map(function (_ref2) {
    var ageMax = _ref2.ageMax,
        ageMin = _ref2.ageMin,
        availability = _ref2.availability,
        id = _ref2.id,
        isIncluded = _ref2.isIncluded,
        remainingStock = _ref2.remainingStock;
    return productChildcareAvailabilities_jsx("p", {
      key: id,
      className: "flex font-bold items-start justify-between mt-10 text-14 text-black"
    }, productChildcareAvailabilities_jsx("span", {
      className: "flex-1"
    }, productChildcareAvailabilities_jsx(AvailabilityAge_AvailabilityAge, {
      ageMax: ageMax,
      ageMin: ageMin,
      childcareLabel: childcareLabel,
      monthsLabel: monthsLabel,
      yearLabel: yearLabel,
      yearsLabel: yearsLabel
    }), productChildcareAvailabilities_jsx("span", {
      className: classnames_default()('font-brand font-normal me-5 text-12', {
        'text-black': isIncluded,
        'text-sienna': !isIncluded
      })
    }, isIncluded ? Object(src_i18n["h" /* t */])('common.included') : Object(src_i18n["h" /* t */])('common.onDemand'))), productChildcareAvailabilities_jsx(Availability_Availability, {
      availability: availability,
      config: renderConfig,
      remainingStock: remainingStock
    }));
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.jsx
















var Product_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
























var Product_Product = function Product(_ref) {
  var _flag$price, _flag$price$bestPrice, _flag$price2, _flag$price2$bestPric, _minAuthorizedAge$val;

  var childcare = _ref.childcare,
      childcareIncluded = _ref.childcareIncluded,
      className = _ref.className,
      _ref$cmtaLinks = _ref.cmtaLinks,
      cmtaLinks = _ref$cmtaLinks === void 0 ? {} : _ref$cmtaLinks,
      comfort = _ref.comfort,
      comparison = _ref.comparison,
      departureDateOn = _ref.departureDateOn,
      _ref$flag = _ref.flag,
      flag = _ref$flag === void 0 ? {} : _ref$flag,
      hasComparison = _ref.hasComparison,
      hasDiscount = _ref.hasDiscount,
      _ref$hasFadeIn = _ref.hasFadeIn,
      hasFadeIn = _ref$hasFadeIn === void 0 ? true : _ref$hasFadeIn,
      hasLazyLoading = _ref.hasLazyLoading,
      header = _ref.header,
      id = _ref.id,
      index = _ref.index,
      _ref$isCompact = _ref.isCompact,
      isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
      isLinkDisabled = _ref.isLinkDisabled,
      _ref$kids = _ref.kids,
      kids = _ref$kids === void 0 ? [] : _ref$kids,
      lineName = _ref.lineName,
      _ref$minAuthorizedAge = _ref.minAuthorizedAge,
      minAuthorizedAge = _ref$minAuthorizedAge === void 0 ? {} : _ref$minAuthorizedAge,
      offer = _ref.offer,
      offerDiscount = _ref.offerDiscount,
      onClick = _ref.onClick,
      onComparisonClick = _ref.onComparisonClick,
      ratioDisplay = _ref.ratioDisplay,
      thumbnail = _ref.thumbnail,
      url = _ref.url;
  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var isGsa = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('isGsa');
  var router = Object(next_router["useRouter"])();

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 2),
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var track = Object(useTracking["a" /* useTracking */])({});
  var pageContext = Object(PageContext["b" /* usePageContext */])();
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';
  var clickThumbnailTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: id,
    resortCode: id,
    resortTrident: typeof comfort === 'number' ? comfort : '',
    thumbnailPrice: (flag === null || flag === void 0 ? void 0 : (_flag$price = flag.price) === null || _flag$price === void 0 ? void 0 : (_flag$price$bestPrice = _flag$price.bestPrice) === null || _flag$price$bestPrice === void 0 ? void 0 : _flag$price$bestPrice.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(camelCase_default()(lineName)) : siteSection,
    thumbnailPosition: index + 1
  } : null;
  var clickIconBubbleTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: "".concat(id, "_infoIcon"),
    resortCode: id,
    thumbnailPrice: (flag === null || flag === void 0 ? void 0 : (_flag$price2 = flag.price) === null || _flag$price2 === void 0 ? void 0 : (_flag$price2$bestPric = _flag$price2.bestPrice) === null || _flag$price2$bestPric === void 0 ? void 0 : _flag$price2$bestPric.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(camelCase_default()(lineName)) : siteSection,
    thumbnailPosition: index + 1,
    siteSection: siteSection
  } : null;
  var linkShouldBeDisabled = isLinkDisabled || hasComparison || isGsa;

  var goOnResort = function goOnResort() {
    var newHistoryState = new DynamicLinkUtil["a" /* default */](dist["windowWrapper"].getLocation(), url ? Object(Product_utils["c" /* generateProductLink */])(url, offer) : '');
    router.push(newHistoryState.toString());
  };

  var minAuthorizedAgeMessage = (minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) === 0 ? Object(src_i18n["h" /* t */])('faceting.availabilities.noChildcareFrom0') : Object(src_i18n["h" /* t */])('faceting.availabilities.noChildcare', {
    min_authorized_age_in_months: Math.floor(((_minAuthorizedAge$val = minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) !== null && _minAuthorizedAge$val !== void 0 ? _minAuthorizedAge$val : 0) / 12)
  });
  var childcareBirthdateAlert = (kids === null || kids === void 0 ? void 0 : kids.length) > 0 && childcare && isEmpty_default()(childcare.items) && !childcareIncluded;
  var noChildcareAlert = kids && kids.length > 0 && kids.some(function (kid) {
    return !kid.birthdate;
  }) && childcareIncluded;
  return Product_jsx("article", {
    className: classnames_default()(className, 'isolate relative', {
      'animate-fadeIn animation-duration-750': hasFadeIn
    }),
    onClick: onClick
  }, Product_jsx("div", {
    className: classnames_default()('isolate relative', {
      'flex gap-10': isCompact
    })
  }, Product_jsx("div", {
    className: classnames_default()('relative', {
      'w-1/2 shrink-0': isCompact
    }),
    "data-testid": "Product-Header-Wrapper"
  }, hasComparison && Product_jsx(ProductComparison_ProductComparison, Object(esm_extends["a" /* default */])({}, comparison, {
    onComparisonClick: onComparisonClick
  })), !!departureDateOn && Product_jsx(Tag["a" /* Tag */], {
    className: "absolute start-0 mx-10 -translate-y-1/2 z-2",
    color: colors["a" /* COLORS */].SIENNA,
    colorBg: colors["a" /* COLORS */].WHITE,
    colorBorder: colors["a" /* COLORS */].SIENNA,
    "data-testid": "Product-departure"
  }, departureDateOn), hasDiscount && Product_jsx(OfferDiscount_OfferDiscount, {
    className: "absolute end-0 mx-10 -translate-y-1/2 z-2",
    discount: offerDiscount === null || offerDiscount === void 0 ? void 0 : offerDiscount.discount,
    i18n: offerDiscount === null || offerDiscount === void 0 ? void 0 : offerDiscount.i18n
  }), Product_jsx(ProductThumbnail["a" /* ProductThumbnail */], Object(esm_extends["a" /* default */])({}, thumbnail, {
    className: "overflow-hidden rounded-12",
    hasLazyLoading: hasLazyLoading,
    isLinkDisabled: true,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    ratioDisplay: ratioDisplay
  }))), Product_jsx(ProductHeader["a" /* ProductHeader */], Object(esm_extends["a" /* default */])({}, header, {
    className: classnames_default()({
      'overflow-hidden': isCompact,
      'mt-10': !isCompact
    }),
    isLinkDisabled: linkShouldBeDisabled,
    link: appContext.isCmta && id && Object(Product_utils["e" /* localeHasCmtaLinks */])(cmtaLinks) ? Object(Product_utils["a" /* generateCmtaLinkProp */])(id, cmtaLinks) : Object(Product_utils["b" /* generateLinkProp */])(url, offer),
    onClick: function onClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    }
  }))), !isEmpty_default()(flag) && Product_jsx(ProductFlag["a" /* ProductFlag */], Object(esm_extends["a" /* default */])({}, flag, {
    isLinkDisabled: linkShouldBeDisabled,
    onClick: goOnResort,
    onCtaClick: function onCtaClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_discoverResort")
        }));
      }
    },
    onEmptyPriceClick: function onEmptyPriceClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    },
    onPriceClick: function onPriceClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_bestPrice")
        }));
      }
    },
    onIconBubbleClick: function onIconBubbleClick() {
      if (Object(src_i18n["d" /* getKeyValue */])('price.displayIconBubble')) {
        track(_objectSpread(_objectSpread({}, clickIconBubbleTrackingData), {}, {
          labelGA: "".concat(id, "_infoIcon")
        }));
      }
    },
    price: flag.price
  })), childcareBirthdateAlert && Product_jsx("div", {
    className: "border-1 border-lightGrey flex gap-5 mt-5 p-10 rounded-12 text-12"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "mt-1 shrink-0",
    color: colors["a" /* COLORS */].RED,
    name: icons["a" /* ICONS */].WARNING,
    width: "1rem"
  }), minAuthorizedAgeMessage), noChildcareAlert && Product_jsx("button", {
    className: "bg-sand hocus:bg-sand-active cursor-pointer flex font-bold gap-5 leading-1 mt-5 p-10 rounded-12 text-12 text-initial text-black transition-colors duration-250 ease-in",
    onClick: function onClick() {
      dispatchCriteriaDisplayContext({
        type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
        payload: 'criteriaWho'
      });
      Object(scrollToElement["a" /* scrollToElement */])('[data-testid="CriteriaWho"]', 600);
    },
    type: "button"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "mt-1 shrink-0",
    name: icons["a" /* ICONS */].KIDS,
    width: "1rem"
  }), Object(src_i18n["h" /* t */])('faceting.availabilities.enterBirthdate')), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('faceting.childcare') && childcare && !isEmpty_default()(childcare.items) && Product_jsx(productChildcareAvailabilities_ProductChildcareAvailabilities, childcare));
};

/***/ }),

/***/ "Z+2E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductThumbnail; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cxan");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("u/u4");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("0IQ5");
/* harmony import */ var _frameworks_image_slideshow_ImageSlideShow__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("DQFb");
/* harmony import */ var _frameworks_tag_Tag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("N5WC");



var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;








var OPENING_STATUS = _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["constants"].OPENING_STATUS;
var ProductThumbnail = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_4__["memo"])(function ProductThumbnail(_ref) {
  var _ref$bottomTags = _ref.bottomTags,
      bottomTags = _ref$bottomTags === void 0 ? [] : _ref$bottomTags,
      className = _ref.className,
      closedLabel = _ref.closedLabel,
      hasLazyLoading = _ref.hasLazyLoading,
      isLinkDisabled = _ref.isLinkDisabled,
      isSliderDisabled = _ref.isSliderDisabled,
      _ref$isTagsDisabled = _ref.isTagsDisabled,
      isTagsDisabled = _ref$isTagsDisabled === void 0 ? false : _ref$isTagsDisabled,
      link = _ref.link,
      nextLabel = _ref.nextLabel,
      openingStatus = _ref.openingStatus,
      _ref$pictures = _ref.pictures,
      pictures = _ref$pictures === void 0 ? [] : _ref$pictures,
      previousLabel = _ref.previousLabel,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 / 3 : _ref$ratioDisplay,
      _ref$topTags = _ref.topTags,
      topTags = _ref$topTags === void 0 ? [] : _ref$topTags;
  var TagName = isLinkDisabled ? 'div' : _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"];
  var defaultPicture = pictures[0] || {};
  return __jsx(TagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('block relative', className)
  }, isLinkDisabled ? null : link), !isSliderDisabled && pictures.length > 1 && openingStatus !== OPENING_STATUS.CLOSED ? __jsx(_frameworks_image_slideshow_ImageSlideShow__WEBPACK_IMPORTED_MODULE_9__[/* ImageSlideShow */ "a"], {
    hasLazyLoading: true,
    itemClassName: "isolate overflow-hidden rounded-12 will-change-transform",
    media: pictures,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "c"].XL,
    ratioDisplay: ratioDisplay
  }) : __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_8__[/* Image */ "a"], {
    altMsg: defaultPicture.alt,
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    groupKey: "thumbnails",
    ratioKey: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_6__[/* default */ "c"].XL,
    ratioDisplay: ratioDisplay,
    hasLazyLoading: hasLazyLoading
  }), !!(topTags === null || topTags === void 0 ? void 0 : topTags.length) && !isTagsDisabled && __jsx("div", {
    className: "absolute flex gap-5 justify-end p-10 top-0 w-full",
    "data-testid": "ProductThumbnail-topTags"
  }, topTags.map(function (tag) {
    return __jsx(_frameworks_tag_Tag__WEBPACK_IMPORTED_MODULE_10__[/* Tag */ "a"], {
      color: tag.color,
      colorBg: tag.colorBg,
      iconName: tag.iconName,
      "data-testid": tag.dataTestId,
      key: tag.dataTestId || tag.label,
      style: tag.style
    }, tag.label);
  })), openingStatus === OPENING_STATUS.CLOSED && __jsx("div", {
    className: "absolute bg-black/60 font-bold inline-flex items-center justify-center overflow-hidden inset-0 rounded-12 text-20 text-white uppercase z-1",
    "data-testid": "ProductThumbnail-closed"
  }, closedLabel), !!(bottomTags === null || bottomTags === void 0 ? void 0 : bottomTags.length) && !isTagsDisabled && __jsx("div", {
    className: "absolute bottom-0 flex gap-5 justify-start p-10 w-full",
    "data-testid": "ProductThumbnail-bottomTags"
  }, bottomTags.map(function (tag) {
    return __jsx(_frameworks_tag_Tag__WEBPACK_IMPORTED_MODULE_10__[/* Tag */ "a"], {
      color: tag.color,
      colorBg: tag.colorBg,
      iconName: tag.iconName,
      "data-testid": tag.dataTestId,
      key: tag.label,
      style: tag.style
    }, tag.label);
  })));
});

/***/ }),

/***/ "hgS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductHeader; });
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MWZw");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;




var ProductHeader = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_2__["memo"])(function ProductHeader(_ref) {
  var className = _ref.className,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? {} : _ref$heading,
      isLinkDisabled = _ref.isLinkDisabled,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {
    url: ''
  } : _ref$link,
      onClick = _ref.onClick;
  var _heading$title = heading.title,
      title = _heading$title === void 0 ? '' : _heading$title,
      _heading$subtitle = heading.subtitle,
      subtitle = _heading$subtitle === void 0 ? '' : _heading$subtitle;
  return __jsx("header", {
    className: className,
    "data-testid": "Product-Header"
  }, __jsx(_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({
    className: "flex flex-col-reverse min-w-0",
    "data-testid": "ProductHeader-link",
    onClick: onClick,
    tagname: "div",
    url: isLinkDisabled ? '' : link.url
  }, isLinkDisabled ? null : link), !isLinkDisabled && __jsx("div", {
    className: "absolute inset-0",
    "data-testid": "ProductHeader-link-overlay"
  }), __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_5__[/* Title */ "a"], {
    className: "flex font-sans font-semibold text-18",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BLACK,
    hasEllipsis: true,
    hLevel: 2,
    theme: "none"
  }, title), __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_5__[/* Title */ "a"], {
    className: "flex font-sans font-semibold text-14",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].SIENNA,
    hasEllipsis: true,
    hLevel: 3,
    theme: "none"
  }, subtitle)));
});

/***/ }),

/***/ "uLWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: Grid

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.jsx
var Responsive = __webpack_require__("Gqxm");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// CONCATENATED MODULE: ./src/client/components/frameworks/more-results/MoreResults.jsx

var __jsx = react_default.a.createElement;




var MoreResults_MoreResults = function MoreResults(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      _ref$number = _ref.number,
      number = _ref$number === void 0 ? 0 : _ref$number,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? noop_default.a : _ref$onClick,
      text = _ref.text;

  if (!number) {
    return null;
  }

  return __jsx("div", {
    className: classnames_default()(className, 'flex justify-center w-full')
  }, __jsx(Button["a" /* Button */], {
    color: colors["a" /* COLORS */].SIENNA,
    colorBg: colors["a" /* COLORS */].TRANSPARENT,
    colorBorder: colors["a" /* COLORS */].SIENNA,
    dataTestId: "more-results-btn",
    isLoading: isLoading,
    onClick: onClick,
    size: "medium"
  }, __jsx("span", {
    "data-testid": "Moreresults-number"
  }, number), " ", text));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/grid/Grid.jsx
















var Grid_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable clubmed/no-fake-component */





function getWidth() {
  var fraction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return fraction < 2 || fraction > 4 ? 'grid-cols-1' : "grid-cols-".concat(fraction);
}

function filterContext(hasOneRemaining, itemsByLine, isSeeMoreVisible) {
  return function (item, index) {
    if (isSeeMoreVisible) {
      return index < itemsByLine;
    }

    return true;
  };
}

var Grid_Grid = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Grid, _Component);

  var _super = _createSuper(Grid);

  function Grid() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Grid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      isExpanded: !_this.props.hasSeeMore
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickSeeMore", function () {
      var _this$props = _this.props,
          _this$props$totalNumb = _this$props.totalNumberToDisplay,
          totalNumberToDisplay = _this$props$totalNumb === void 0 ? 0 : _this$props$totalNumb,
          _this$props$getChildr = _this$props.getChildren,
          getChildren = _this$props$getChildr === void 0 ? function () {
        return Promise.resolve({});
      } : _this$props$getChildr,
          _this$props$isSynchro = _this$props.isSynchronousGrid,
          isSynchronousGrid = _this$props$isSynchro === void 0 ? false : _this$props$isSynchro;

      if (isSynchronousGrid || totalNumberToDisplay === _this.getItemsByLine()) {
        _this.setState({
          isExpanded: true
        });
      }

      if (totalNumberToDisplay > _this.getItemsByLine()) {
        getChildren();
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Grid, [{
    key: "getGrid",
    value: function getGrid() {
      var _this$props$grid = this.props.grid,
          grid = _this$props$grid === void 0 ? {} : _this$props$grid;
      var desktop = grid.desktop,
          tablet = grid.tablet,
          phablet = grid.phablet,
          mobile = grid.mobile;
      return "".concat(getWidth(mobile), " sm:").concat(getWidth(phablet), " md:").concat(getWidth(tablet), " lg:").concat(getWidth(desktop));
    }
  }, {
    key: "getItemsByLine",
    value: function getItemsByLine() {
      var _this$props2 = this.props,
          _this$props2$display = _this$props2.display,
          display = _this$props2$display === void 0 ? {} : _this$props2$display,
          _this$props2$responsi = _this$props2.responsive,
          responsive = _this$props2$responsi === void 0 ? {} : _this$props2$responsi;
      var _display$desktop = display.desktop,
          desktop = _display$desktop === void 0 ? 1 : _display$desktop,
          _display$tablet = display.tablet,
          tablet = _display$tablet === void 0 ? 1 : _display$tablet,
          _display$phablet = display.phablet,
          phablet = _display$phablet === void 0 ? 1 : _display$phablet,
          _display$mobile = display.mobile,
          mobile = _display$mobile === void 0 ? 1 : _display$mobile;
      var _responsive$isBrowser = responsive.isBrowserGreaterThan,
          isBrowserGreaterThan = _responsive$isBrowser === void 0 ? {} : _responsive$isBrowser;

      if (isBrowserGreaterThan.M && desktop > -1) {
        return desktop;
      }

      if (isBrowserGreaterThan.S && tablet > -1) {
        return tablet;
      }

      if (isBrowserGreaterThan.XS && phablet > -1) {
        return phablet;
      }

      return mobile;
    }
  }, {
    key: "getNumberOfItemsByLineExcludingSeeMore",
    value: function getNumberOfItemsByLineExcludingSeeMore() {
      return this.getItemsByLine();
    }
  }, {
    key: "getRest",
    value: function getRest() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          totalNumberToDisplay = _this$props3.totalNumberToDisplay;
      return totalNumberToDisplay ? totalNumberToDisplay - this.getItemsByLine() : react["Children"].count(children) - this.getItemsByLine();
    }
  }, {
    key: "getSeeMore",
    value: function getSeeMore() {
      var _this$props4 = this.props,
          hasSeeMore = _this$props4.hasSeeMore,
          isLoading = _this$props4.isLoading,
          seeMore = _this$props4.seeMore;
      return hasSeeMore && this.getRest() > 0 && !this.state.isExpanded ? Grid_jsx(MoreResults_MoreResults, Object(esm_extends["a" /* default */])({}, seeMore, {
        className: "mt-20",
        isLoading: isLoading,
        number: this.getRest(),
        onClick: this.onClickSeeMore
      })) : null;
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this2 = this;

      var hasOneRemaining = this.getRest() === 1;
      var filterItem = filterContext(hasOneRemaining, this.getNumberOfItemsByLineExcludingSeeMore(), !this.state.isExpanded);
      return react["Children"].toArray(this.props.children).filter(filterItem).map(function (item) {
        return Grid_jsx("div", {
          className: classnames_default()('animate-fadeIn animation-duration-500', _this2.props.childrenClassName),
          "data-testid": "Grid-item",
          key: item.key
        }, item);
      });
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return Object(toConsumableArray["a" /* default */])(this.getChildren()).filter(function (i) {
        return i;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var isLoading = _ref.isLoading;

      if (isLoading && !this.props.isLoading && !this.state.isExpanded) {
        this.setState({
          isExpanded: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var items = this.getItems();
      return items.length ? Grid_jsx(react["Fragment"], null, Grid_jsx("div", {
        className: classnames_default()(className, 'gap-20 grid relative', this.getGrid()),
        "data-testid": "grid"
      }, items.map(function (item, index) {
        return (
          /* eslint-disable react/no-array-index-key */
          Grid_jsx(react["Fragment"], {
            key: index
          }, item)
        );
      })), this.getSeeMore()) : null;
    }
  }]);

  return Grid;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Grid_Grid, "defaultProps", {
  display: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  },
  getChildren: function getChildren() {
    return Promise.resolve({});
  },
  grid: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  }
});

/* harmony default export */ var grid_Grid = __webpack_exports__["a"] = (Object(Responsive["a" /* default */])(Grid_Grid));

/***/ }),

/***/ "yfdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductPriceModal_ProductPriceModal; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.utils.js

var ProductPriceModal_utils_getLabel = function getLabel(_ref) {
  var isJoyview = _ref.isJoyview,
      isTour = _ref.isTour;

  if (isTour) {
    return '';
  }

  return isJoyview ? Object(i18n["h" /* t */])('resort.startingPrice.roomOnly') : Object(i18n["h" /* t */])('resort.startingPrice.allInclusive');
};
// EXTERNAL MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx + 1 modules
var PopOver = __webpack_require__("Xzib");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx
var __jsx = react_default.a.createElement;




var ProductPriceModal_ProductPriceModal = function ProductPriceModal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      city = _ref.city,
      endDate = _ref.endDate,
      _ref$hasTransport = _ref.hasTransport,
      hasTransport = _ref$hasTransport === void 0 ? false : _ref$hasTransport,
      _ref$isCruise = _ref.isCruise,
      isCruise = _ref$isCruise === void 0 ? false : _ref$isCruise,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      _ref$isTour = _ref.isTour,
      isTour = _ref$isTour === void 0 ? false : _ref$isTour,
      onClick = _ref.onClick,
      onClickButton = _ref.onClickButton,
      rate = _ref.rate,
      startDate = _ref.startDate,
      unit = _ref.unit;

  if (!react["Children"].count(children)) {
    return null;
  }

  return __jsx(PopOver["a" /* PopOver */], {
    ariaLabel: ProductPriceModal_utils_getLabel({
      isJoyview: isJoyview,
      isTour: isTour
    }),
    className: className,
    content: __jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
      city: city,
      endDate: endDate,
      hasTransport: hasTransport,
      isCruise: isCruise,
      isJoyview: isJoyview,
      isTour: isTour,
      onClick: onClickButton,
      rate: rate,
      startDate: startDate,
      unit: unit
    }),
    isModalOnly: true,
    onClick: onClick
  }, children);
};

/***/ })

}]);